const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    language: state => state.settings.language,
    loginStatus: state => state.users.loginStatus,
    roles: state => state.users.roles,
    permission_routes: state => state.permission.routers,
}
export default getters